module.exports = __webpack_public_path__ + "static/media/icon-white.e5a60f9d.png";